// extracted by mini-css-extract-plugin
export default {"card":"Mog73wosYRJLmbVqLTc2y","container":"_3Smm5KxQhkJIl0wBULd3Qc","focused":"_1pLV_CtCZ0d9AUNoWYskUi","transparent":"_2K4UR0wHEivd0KHFnpezDG"};